const notificationConstants = {
  LISTENING_FOR_NEW_NOTIFICATION: "LISTENING_FOR_NEW_NOTIFICATION",
  MARK_NOTIFICATION_AS_READ: "MARK_NOTIFICATION_AS_READ",
  NOTIFICATION_TYPE_PROFILE_VIEW: "VIEW_PROFILE",
  NOTIFICATION_TYPE_CONNECT_REQUEST: "CONNECT_REQUEST",
  NOTIFICATION_TYPE_CONNECT_APPROVED: "CONNECT_APPROVED",
  GET_NOTIFICATIONS_LIST: "GET_NOTIFICATIONS_LIST",
  LOAD_MORE_NOTIFICATIONS: "LOAD_MORE_NOTIFICATIONS",
  CHANGE_NOTIFICATION_LAST_RESULT: "CHANGE_NOTIFICATION_LAST_RESULT",
  MARK_ALL_NOTIFICATIONS_AS_READ: "MARK_ALL_NOTIFICATIONS_AS_READ"
};
export default notificationConstants;



// WEBPACK FOOTER //
// ./src/_constants/notificationConstants.js